













































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { localize, extend } from 'vee-validate';
import Input from '@/components/common/elements/Input.vue';
import Select from '@/components/common/elements/Select.vue';
import { InputProps, SelectProps } from '@/constants/form/types';
import RegistInputHeaderForm from '@/components/construction/constructionregister/RegistInputHeaderForm.vue';
import RegistInputForm from '@/components/construction/constructionregister/RegistInputForm.vue';
import ApiResponseDialog from '@/components/common/modules/ApiResponseDialog.vue';
import {
  periodProp,
  constructionIdProp,
  subjectProps
} from '@/constants/construction/construction';

@Component({
  components: { Input, Select, ApiResponseDialog,RegistInputHeaderForm,RegistInputForm }
})
export default class RegistPanelComponent extends Vue {
  // ダイアログ表示制御
  private dialogStatus = false;

  // Validationエラー制御
  private invalid = true;

  // 処理実行後のAPIレスポンス
  @Prop()
  private apiResponse: any;
  @Prop()
  private apiSuccessMessage: any;
  @Prop()
  private basicFieldData: any;
  @Prop()
  private basicFieldCols: any; 
  
  private onClickCancel(): void {
    this.$router.push({ name: 'ConstructionList'});
  }
  /**
   * 子コンポーネントからEmitされる値をコンソールに出力
   * （値が渡されるか確認用）
   * @module catchInput
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void} - コンソールに出力
   */
  @Emit('catchInput')
  private catchInput(response: any) {
    return response;
  }

  /**
   * 子コンポーネントからEmitされる値を親コンポーネントに
   * （値が渡されるか確認用）
   * @module buttonAction
   * @param {string} type - 押下されたボタンのタイプ
   * @return {string} - 押下されたボタンのタイプ
   */
  @Emit('buttonAction')
  private buttonAction(type: string): string {
    return type;
  }

  /**
   * ポップアップの処理完了時確認ボタン押下時処理
   * ポップアップを閉じる前に
   * @returns {void} - 内部プロパティ変更
   */
  @Emit('successOpratipon')
  private successOpratipon(): void {
    this.dialogStatus = false;
  }

  /**
   * ポップアップのキャンセルボタン押下時処理
   * @returns {void} - ポップアップ状態変更（閉じる）
   */
  private catchPopup(): void {
    this.dialogStatus = false;
  }
}
